export default class Beneficiaire {
    constructor() {
        this.nombreEleve =  null
        this.typeEtablissement = ["ECOLE MATERNELLE", "ECOLE PRIMAIRE", "ECOLE SECONDAIRE", "LYCEE", "ECOLE UNIVERSITAIRE", "ECOLE DE FORMATION"]
        this.nomEtablissement = null
        this.coordonne = {
            nom : null,
            prenom : null,
            email : null,
            telephone : null
        }
        this.type = null

    }
}